import { validateAutomation } from './validateAutomation';
export default validateAutomation;
